import Plyr from 'plyr';

export default class Video {
  constructor(videos, options) {
    const playerControls = {
      playButtonIcon: '<button type="button" class="plyr__control plyr__control--overlaid" aria-label="Play, {title}" data-plyr="play"><svg class="play-icon-button-control" width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="60" height="60" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M23 20V40L39 29.4248L23 20Z" fill="#323232"/></svg><span class="plyr__sr-only">Play</span></button>',
      playButton: '<button type="button" class="plyr__controls__item plyr__control" aria-label="Play, {title}" data-plyr="play"><svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-pause"></use></svg><svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-play"></use></svg><span class="label--pressed plyr__tooltip" role="tooltip">Pause</span><span class="label--not-pressed plyr__tooltip" role="tooltip">Play</span></button>',
      muteButton: '<button type="button" class="plyr__controls__item plyr__control" aria-label="Mute" data-plyr="mute"><svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-muted"></use></svg><svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-volume"></use></svg><span class="label--pressed plyr__tooltip" role="tooltip">Unmute</span><span class="label--not-pressed plyr__tooltip" role="tooltip">Mute</span></button>',
      progressInput: '<div class="plyr__controls__item plyr__progress__container"><div class="plyr__progress"><input data-plyr="seek" type="range" min="0" max="100" step="0.01" value="0" aria-label="Seek"><progress class="plyr__progress__buffer" min="0" max="100" value="0">% buffered</progress><span role="tooltip" class="plyr__tooltip">00:00</span></div></div>',
      volume: '<div class="plyr__controls__item plyr__volume"><input data-plyr="volume" type="range" min="0" max="1" step="0.05" value="1" autocomplete="off" aria-label="Volume"></div>',
      fullscreen: '<button type="button" class="plyr__controls__item plyr__control" data-plyr="fullscreen"><svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-exit-fullscreen"></use></svg><svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-enter-fullscreen"></use></svg><span class="label--pressed plyr__tooltip" role="tooltip">Exit fullscreen</span><span class="label--not-pressed plyr__tooltip" role="tooltip">Enter fullscreen</span></button>',
    };

    const controls = `${playerControls.playButtonIcon} <div class="plyr__controls"> ${playerControls.playButton} ${playerControls.progressInput} ${playerControls.muteButton} ${playerControls.volume} ${playerControls.fullscreen} </div>`;

    const defaultConfig = {
      controls,
      fullscreen: {
        enabled: true,
        fallback: true,
        iosNative: true,
      },
      storage: {
        enabled: false,
      },
    };

    this.play = this.play.bind(this);
    this.pause = this.pause.bind(this);

    if (options) {
      this.config = { ...options, ...defaultConfig };
    } else {
      this.config = defaultConfig;
    }

    if (videos.length > 1) {
      this.player = Plyr.setup(videos, this.config);

      if (!this.player) { return; }

      // Adds plyr video id to video wrapper for html5 and vimeo videos
      this.player.forEach(player => {
        const { provider, id } = player;
        let video;

        if (provider === 'html5') {
          video = player.elements.wrapper.querySelector('video');
          video.setAttribute('data-plyr-video-id', id);
        }

        if (provider === 'vimeo') {
          player.on('ready', event => {
            const instance = event.detail.plyr;
            video = player.elements.wrapper;
            video.setAttribute('data-plyr-video-id', instance.id);
          });
        }
      });
    } else {
      this.player = new Plyr(videos, this.config);

      if (!this.player) { return; }

      // Adds plyr video id to video wrapper for html5 and vimeo videos
      const { provider, id } = this.player;
      let video;

      if (provider === 'html5') {
        video = this.player.elements.wrapper.querySelector('video');
        video.setAttribute('data-plyr-video-id', id);
      }

      if (provider === 'vimeo') {
        this.player.on('ready', event => {
          const instance = event.detail.plyr;
          video = this.player.elements.wrapper;
          video.setAttribute('data-plyr-video-id', instance.id);
        });
      }
    }
  }

  play() {
    if (this.player) {
      this.player.play();
    }
  }

  pause() {
    if (this.player) {
      this.player.pause();
    }
  }

  unload() {
    if (!this.player) { return; }
    if (this.player.length > 1) {
      this.player.forEach(player => player.destroy());
    } else {
      this.player.destroy();
    }
  }
}
